import { isEmpty, isNull } from "lodash";
import React, { useEffect } from "react";
import { useAuthorizedDSPs } from "../hooks/useLps/useAuthorizedDSPs";
import { useAuthorizedEntities } from "../hooks/useLps/useAuthorizedEntities";
import { useAuthorizedLps } from "../hooks/useLps/useAuthorizedLps";
import { useLpSelected } from "../hooks/useLps/useLpSelected";
var CLWSAuthZCaller = function(param) {
    var authorizationDispatch = param.authorizationDispatch;
    var dispatchGetAuthorizedEntities = authorizationDispatch.dispatchGetAuthorizedEntities, dispatchGetAuthorizedLps = authorizationDispatch.dispatchGetAuthorizedLps, dispatchGetLPDetails = authorizationDispatch.dispatchGetLPDetails, dispatchGetAuthorizedDSPs = authorizationDispatch.dispatchGetAuthorizedDSPs;
    var authorizedEntities = useAuthorizedEntities();
    var lpSelected = useLpSelected();
    var authorizedLps = useAuthorizedLps();
    var authorizedDSPs = useAuthorizedDSPs();
    useEffect(function() {
        if (isEmpty(authorizedEntities)) return;
        dispatchGetAuthorizedEntities(authorizedEntities);
    }, [
        authorizedEntities
    ]);
    useEffect(function() {
        if (isEmpty(lpSelected)) return;
        dispatchGetLPDetails(lpSelected);
    }, [
        lpSelected
    ]);
    useEffect(function() {
        if (isNull(authorizedLps)) return;
        dispatchGetAuthorizedLps(authorizedLps);
    }, [
        authorizedLps
    ]);
    useEffect(function() {
        if (isNull(authorizedDSPs)) return;
        dispatchGetAuthorizedDSPs(authorizedDSPs);
    }, [
        authorizedLps
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null);
};
export default CLWSAuthZCaller;

//# sourceMappingURL=CLWSAuthZCaller.js.map